import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'container',
    wrap: 'lg:flex lg:gap-20 xl:pr-20 xl:pl-2',
    left: 'flex flex-none justify-center lg:w-100 lg:flex-col lg:items-end lg:justify-start',
    right: ''
  }
});
